import React, { createRef } from 'react';
import { BrokenImageLinkTest } from '../../components/BrokenImageLinkTest';
import { withUser } from '../../user/UserContext';
import { NavUserDropdown } from './NavUserDropdown';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { UserContextType } from '../../user/user.types';

type Props = {
  cancelHover: Function;
} & UserContextType;

type State = {
  showNav: boolean;
};

export class RawNavUser extends React.Component<Props, State> {
  state: State = {
    showNav: false,
  };

  userNavContainer = createRef<HTMLDivElement>();

  componentDidMount() {
    window.addEventListener('click', this.showUserNavCallback);
    window.addEventListener('touchstart', this.showUserNavCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.showUserNavCallback);
    window.removeEventListener('touchstart', this.showUserNavCallback);
  }

  showUserNavCallback = (event: any) => {
    const { cancelHover } = this.props;
    if (
      this.userNavContainer.current &&
      !this.userNavContainer.current.contains(event.target) &&
      this.state.showNav
    ) {
      this.setState({ showNav: false }, () => cancelHover(false, 'user'));
    }
  };

  openUserDropdownClicked = () => {
    const { cancelHover } = this.props;
    const { showNav } = this.state;
    if (showNav) {
      this.setState({ showNav: false }, () => cancelHover(false, 'user'));
    } else {
      this.setState({ showNav: true }, () => cancelHover(true, 'user'));
      doctrineAnalytics('Nav ButtonProfileClicked');
    }
  };

  render() {
    const { showNav } = this.state;
    const { currentUser } = this.props;
    return (
      <div
        ref={this.userNavContainer}
        className="nav__item nav__item--row nav-user"
        onClick={this.openUserDropdownClicked}
        id="header-user-picture"
      >
        <BrokenImageLinkTest url={currentUser.pictureUrl}>
          {(isImageLinkBroken: boolean) => (
            <img
              className="nav-user__picture"
              src={
                currentUser.pictureUrl && !isImageLinkBroken
                  ? currentUser.pictureUrl
                  : '/img/user/user_icon.png'
              }
              alt={currentUser.name}
            />
          )}
        </BrokenImageLinkTest>

        <div className="nav-user__username" data-test-id="nav-user-name">
          {currentUser.name.length > 22
            ? `${currentUser.name.substring(0, 22)}...`
            : currentUser.name}
        </div>

        <NavUserDropdown showNav={showNav} />
      </div>
    );
  }
}

export const NavUser = withUser(RawNavUser);
